/**
 * @file Refunds (part of) a payment through `payment/:id/refund` and confirms it in a snackbar.
 * A refusal the refund route is known to send opens the refusal dialog with that path's texts.
 */
import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ErrorHandlerSequence, ExpectedErrors } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import { ActionInterface } from "../../Interface/ActionInterface";
import Translator from "../../Translation/Translator";

const EXPECTED_ERRORS: ExpectedErrors = {
  be_payment_not_found: { titleKey: "refusal-title-refund", bodyKey: "refusal-body-payment-not-found" },
  cannot_refund_payment_without_counterparty: { titleKey: "refusal-title-refund", bodyKey: "refusal-body-refund-no-counterparty" },
  payment_is_fully_used: { titleKey: "refusal-title-refund", bodyKey: "refusal-body-refund-nothing-left" },
  used_amount_of_payment_cannot_be_more_than_amount: { titleKey: "refusal-title-refund", bodyKey: "refusal-body-refund-amount-too-large" },
  savings_payment_was_not_removed: { titleKey: "refusal-title-refund", bodyKey: "refusal-body-refund-special-payment" },
  cannot_refund_payment_linked_to_direct_charge: { titleKey: "refusal-title-refund", bodyKey: "refusal-body-refund-direct-charge" },
  financial_operations_were_blocked: { titleKey: "refusal-title-refund", bodyKey: "refusal-body-financial-processing-busy" },
  cannot_pay_charge_with_type_of_currency_different_from_payment: { titleKey: "refusal-title-refund", bodyKey: "refusal-body-refund-currency" }
};

export default function* paymentRefund(action: ActionInterface): any {
  try {
    yield put({
      type: Constants.GLOBAL_PAYMENT_REFUND_REQUEST
    });

    yield call(Http.post, `payment/${action.payload?.payment?.id}/refund`, {
      amount: action.payload?.amount,
      description: action.payload?.description,
    });

    yield put({
      type: Constants.GLOBAL_PAYMENT_REFUND_SUCCESS
    });

    yield put({
      type: Constants.GLOBAL_CHARGES_LIST_OUTDATE_REQUESTS
    })

    yield put({
      type: Constants.GLOBAL_PAYMENTS_LIST_OUTDATE_REQUESTS
    })

    yield put({
      type: Constants.SNACKBAR_ADD_MESSAGE,
      payload: {
        message: Translator.trans("snackbar-message-payment-refunded-successfully"),
        type: "success"
      }
    });

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this);
    }
  } catch (err) {
    yield ErrorHandlerSequence(err, action, EXPECTED_ERRORS);

    yield put({
      type: Constants.GLOBAL_PAYMENT_REFUND_FAILURE,
      payload: {
        err: err
      }
    });
  }
}

export function* watchPaymentRefund() {
  yield takeEvery(Constants.GLOBAL_PAYMENT_REFUND_START, paymentRefund);
}
